export const mutationsMixin = () => {
  return {
    setCollection (state, collection) {
      state.collection = collection
    },

    setSingle (state, single) {
      state.selected = single
    },

    setMeta (state, meta) {
      state.meta = { ...state.meta, ...meta }
    },

    setLoading (state, loading) {
      state.loading = loading
    }
  }
}
